import React from 'react';
import SocialListContainer from '../containers/SocialListContainer';
import './Footer.css';

export default () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="footer__data">
        <h3>Grupo Propuesta Ciudadana</h3>
        <div>
          <i className="material-icons">place</i>
          <span>Calle Alberto Arca Parró 180B, San Isidro</span>
        </div>
        <div>
          <i className="material-icons">phone</i>
          <span>(+51) 01 393 8286 - (+51) 01 421 6204</span>
        </div>
        <div>
          <i className="material-icons">laptop</i>
          <a href="https://propuestaciudadana.org.pe/">
            propuestaciudadana.org.pe
          </a>
        </div>
      </div>
      <SocialListContainer />
      <div className="copyright">©2018 Reconstrucción.pe</div>
    </div>
  </footer>
);



// WEBPACK FOOTER //
// ./src/components/Footer.js